import { Icon } from './chunk-3QHO3DXX.js';
import { $$_create_component, $$_create_walker, $$_insert_at_marker_lite, $$_next_template, $$_create_template } from 'maverick.js/dom';
import { arrowLeftPaths, chevronRightPaths } from 'media-icons';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><span slot="label"><!$></span>`);
var $$_templ_2 = /* @__PURE__ */ $$_create_template(`<!$><div slot="hint"></div>`);
function renderMenuButtonContent({ label, iconPaths }) {
  return [
    $$_create_component(Icon, { slot: "close-icon", paths: arrowLeftPaths }),
    $$_create_component(Icon, { slot: "icon", paths: iconPaths }),
    (() => {
      const [$$_root, $$_walker] = $$_create_walker($$_templ), $$_expr = $$_walker.nextNode();
      $$_insert_at_marker_lite($$_expr, label);
      return $$_root;
    })(),
    $$_next_template($$_templ_2),
    $$_create_component(Icon, { slot: "open-icon", paths: chevronRightPaths })
  ];
}

export { renderMenuButtonContent };
